"use client";

import * as AvatarPrimitive from "@radix-ui/react-avatar";
import * as React from "react";

import { css, sva } from "@/../styled-system/css";

const avatar = sva({
  slots: ["root", "image", "fallback"],
  base: {
    root: {
      position: "relative",
      display: "flex",
      flexShrink: "0",
      overflow: "hidden",
      rounded: "full",
    },
    image: {
      aspectRatio: "square",
      h: "full",
      w: "full",
    },
    fallback: {
      display: "flex",
      h: "full",
      w: "full",
      alignItems: "center",
      justifyContent: "center",
      rounded: "full",
      backgroundColor: "brandTeal",
    },
  },
});

const { root, image, fallback } = avatar.raw();

const Avatar = React.forwardRef<
  React.ElementRef<typeof AvatarPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Root> & { css?: object }
>(({ css: cssProp = {}, ...props }, ref) => {
  const className = css(root, cssProp);

  return <AvatarPrimitive.Root ref={ref} className={className} {...props} />;
});
Avatar.displayName = AvatarPrimitive.Root.displayName;

const AvatarImage = React.forwardRef<
  React.ElementRef<typeof AvatarPrimitive.Image>,
  React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Image> & {
    css?: object;
  }
>(({ css: cssProp = {}, ...props }, ref) => {
  const className = css(image, cssProp);

  return <AvatarPrimitive.Image ref={ref} className={className} {...props} />;
});
AvatarImage.displayName = AvatarPrimitive.Image.displayName;

const AvatarFallback = React.forwardRef<
  React.ElementRef<typeof AvatarPrimitive.Fallback>,
  React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Fallback> & {
    css?: object;
  }
>(({ css: cssProp = {}, ...props }, ref) => {
  const className = css(fallback, cssProp);

  return (
    <AvatarPrimitive.Fallback ref={ref} className={className} {...props} />
  );
});
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;

export { Avatar, AvatarFallback, AvatarImage };
